<template>
  <div class="dashboard__sidebar">
    <router-link to="/advertiser/" class="dashboard__logo">
      <img src="/static/img/admin/logo.svg" alt="" class="dashboard__logo-img">
    </router-link>
    <div class="dashboard__user-status">
      <div class="dashboard__user-status-icon">
        <img src="/static/img/admin/user-status.svg" alt="" class="dashboard__user-status-icon-img">
      </div>
      <div class="dashboard__user-status-info">
        <h3 class="dashboard__user-status-title">PLATINUM STATUS</h3>
        <div class="dashboard__user-status-date">19 May 2018 <i class="fa fa-clock-o dashboard__user-status-date-icon"></i> 12:45</div>
      </div>
    </div>
    <nav class="dashboard__nav">
      <div class="dashboard__nav-item">
        <div class="dashboard__nav-item-head">
          <div class="dashboard__nav-item-icon">
            <img src="/static/img/admin/nav-01.svg" alt="" class="dashboard__nav-item-icon-img">
          </div>
          <div class="dashboard__nav-item-name">Create Campaigns</div>
        </div>
        <div class="dashboard__nav-item-list">
          <a href="#" class="dashboard__nav-item-link dashboard__nav-item-link--active">Popunder Campaign</a>
          <a href="#" class="dashboard__nav-item-link">Native Campaign</a>
        </div>
      </div>

      <div class="dashboard__nav-item">
        <div class="dashboard__nav-item-head">
          <div class="dashboard__nav-item-icon">
            <img src="/static/img/admin/nav-02.svg" alt="" class="dashboard__nav-item-icon-img">
          </div>
          <div class="dashboard__nav-item-name">Campaigns Manager</div>
        </div>
        <div class="dashboard__nav-item-list">
          <a href="#" class="dashboard__nav-item-link">Campaigns</a>
          <a href="#" class="dashboard__nav-item-link">Creatives</a>
          <router-link to="/advertiser/campaigns-manager/domains" class="dashboard__nav-item-link">Domain lists</router-link>
          <router-link to="/advertiser/campaigns-manager/iplist" class="dashboard__nav-item-link">IP lists</router-link>
        </div>
      </div>
      <div class="dashboard__nav-item">
        <div class="dashboard__nav-item-head">
          <div class="dashboard__nav-item-icon">
            <img src="/static/img/admin/nav-03.svg" alt="" class="dashboard__nav-item-icon-img">
          </div>
          <div class="dashboard__nav-item-name">Reports manager</div>
        </div>
        <div class="dashboard__nav-item-list">
          <router-link to="/advertiser/reports/bydate" class="dashboard__nav-item-link">By Date</router-link>
          <a href="#" class="dashboard__nav-item-link">By Campaign</a>
          <a href="#" class="dashboard__nav-item-link">By Country</a>
        </div>
      </div>
      <div class="dashboard__nav-item">
        <div class="dashboard__nav-item-head">
          <div class="dashboard__nav-item-icon">
            <img src="/static/img/admin/nav-04.svg" alt="" class="dashboard__nav-item-icon-img">
          </div>
          <div class="dashboard__nav-item-name">Budget Manager</div>
        </div>
        <div class="dashboard__nav-item-list">
          <a href="#" class="dashboard__nav-item-link">Coupons</a>
          <a href="#" class="dashboard__nav-item-link">Transactions</a>
          <a href="#" class="dashboard__nav-item-link">Add funds</a>
        </div>
      </div>
      <div class="dashboard__nav-item">
        <div class="dashboard__nav-item-head">
          <div class="dashboard__nav-item-icon">
            <img src="/static/img/admin/nav-05.svg" alt="" class="dashboard__nav-item-icon-img">
          </div>
          <div class="dashboard__nav-item-name">Settings</div>
        </div>
        <div class="dashboard__nav-item-list">
          <a href="#" class="dashboard__nav-item-link">Edit Account</a>
        </div>
      </div>
      <div class="dashboard__nav-item">
        <div class="dashboard__nav-item-head">
          <div class="dashboard__nav-item-icon">
            <img src="/static/img/admin/nav-06.svg" alt="" class="dashboard__nav-item-icon-img">
          </div>
          <div class="dashboard__nav-item-name">Tools</div>
        </div>
        <div class="dashboard__nav-item-list">
          <a href="#" class="dashboard__nav-item-link">Notifications</a>
          <a href="#" class="dashboard__nav-item-link">TBD (To Be Defined)</a>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import $ from 'jquery'

export default {
  name: 'Menu',
  mounted: function () {
    $('.dashboard__nav-item').on('click', function () {
      $(this).toggleClass('dashboard__nav-item--active').siblings().removeClass('dashboard__nav-item--active')
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/advertiser/menu.vue